<template>
  <tippy-tooltip :class="$attrs.class">
    <a
      v-bind="{...$attrs, class: undefined}"
      ref="btnRef"
      role="button"
    >
      <img :src="CancelIcon" alt="" />
    </a>

    <template #content>
      <span>Cancel</span>
      <kbd class="bg-white text-black-50 ml-1">esc</kbd>
    </template>
  </tippy-tooltip>
</template>

<script>
import TippyTooltip from '../../../common/tippy-tooltip.vue'
import { CancelIcon } from '../../../common/icons'
import { ref } from 'vue'
import { onKeyStroke } from '@vueuse/core'
export default {
  name: 'WebcamRecorderCancelRecordingButton',
  components: { TippyTooltip },
  inheritAttrs: false,
  setup () {
    const btnRef = ref(null)

    onKeyStroke('Escape', () => {
      btnRef.value?.click()
    })

    return {
      btnRef,
      CancelIcon
    }
  }
}
</script>
